import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, GetECpfValidation } from './types';

export const INITIAL_STATE: GetECpfValidation = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): GetECpfValidation {
	return produce(state, draft => {
		switch (action.type) {
			case Types.GET_E_CPF_VALIDATION_REQUEST: {
				break;
			}

			case Types.GET_E_CPF_VALIDATION_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.GET_E_CPF_VALIDATION_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.GET_E_CPF_VALIDATION_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			default:
		}
		return draft;
	});
}
